
"use client";

import { useState } from 'react';
import { Layout, Modal, Form, Input, Select, Button, notification } from 'antd';
import styles from './Price.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { useLocale, useTranslations } from 'next-intl';
import { PRICE_DATA } from './constants';
import { PriceModal } from './ui/PriceModal';

const { Content } = Layout;


export const Price = () => {
  const t = useTranslations('price'); 
  const [selected, setSelected] = useState<string | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [form] = Form.useForm();

  const handleStart = (plan?: string) => {
    if (plan) {form.setFieldsValue({ plan: plan });} 
    else if (selected) form.setFieldsValue({ plan: selected });
    setModalOpen(true);
  };


  return (
    <Content className={styles.root} id="plan">
      <ScrollReveal className={styles.root_title}>
        <h1>{t('title')}</h1>
      </ScrollReveal>

      <ScrollReveal className={styles.root_cards}>
        {PRICE_DATA.map((item) => (
          <section
            key={item.id}
            className={`${styles.root_cards_item} ${selected === item.plan ? styles.selected : ''}`}
            onClick={() => {setSelected(item.plan);  handleStart(item.plan); }}
          >
            {item.popular && (
              <span className={styles.root_cards_item_badge}>{t('popular')}</span>
            )}
            <h3 className={styles.root_cards_item_title}>{t(`${item.plan}.name`)}</h3>
            <ul className={styles.root_cards_item_features}>
              {item.features.map((f, i) => (
                <li key={i}>{t(`${item.plan}.${f}`)}</li>
              ))}
            </ul>
            <div className={styles.root_cards_item_price}>
              <span className={styles.root_cards_item_price_label}>{t('priceLabel')}</span>
              <span className={styles.root_cards_item_price_amount}>
                {t(`${item.plan}.price`)}
                {t(`${item.plan}.oldPrice`) && (
                  <span className={styles.root_cards_item_price_old}>
                    {t(`${item.plan}.oldPrice`)}
                  </span>
                )}
                <span>{t(`${item.plan}.period`)}</span>
              </span>
            </div>
          </section>
        ))}
      </ScrollReveal>

      <Button
        className={styles.btnCtaPrimary}
        onClick={() => handleStart()}
      >
        {t('startBtn')}
      </Button>
      <PriceModal form={form} isOpen={modalOpen} onClose={() => setModalOpen(false)}/>
    </Content>
  );
};
